/**
 * footer menu data
 */
const footerData = {
    about: [
        {
            "path": "/about-us",
            "menu_title": "footer.aboutUs"
        },
        {
            "path": "/term-and-condition",
            "menu_title": "footer.termsAndCondition"
        },
        {
            "path": "/privacy-policy",
            "menu_title": "footer.PrivacyPolicy"
        },
        {
            "path": "/faq",
            "menu_title": "footer.Faq"
        },
        {
            "path": "/contact-us",
            "menu_title": "footer.contactUs"
        }
    ],
    session: [
        {
            "path": "/sign-in",
            "menu_title": "footer.signIn"
        },
        {
            "path": "/sign-up",
            "menu_title": "footer.register"
        },
        {
            "path": "/forget-password",
            "menu_title": "footer.forgetPassword"
        },
        {
            "path": "/thank-you",
            "menu_title": "footer.thankYou"
        }
    ],
    categories: [
        {
            "path": "/shop",
            "menu_title": "footer.women"
        },
        {
            "path": "/shop",
            "menu_title": "footer.men"
        },
        {
            "path": "/shop",
            "menu_title": "footer.accessories"
        },
        {
            "path": "/shop",
            "menu_title": "footer.gadgets"
        }
    ],
    social: [
        {
            "path": "https://www.facebook.com/mytesladeals",
            "menu_title": "footer.facebook"
        },
        {
            "path": "https://twitter.com/mytesladeals",
            "menu_title": "footer.twitter"
        },
        {
            "path": "https://www.youtube.com/mytesladeals",
            "menu_title": "footer.youtube"
        }
    ]
}
export default footerData;


// WEBPACK FOOTER //
// ./src/assets/data/footerData.js